// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "PageDescription-module--cds--assistive-text--UViZ9";
export var cdsVisuallyHidden = "PageDescription-module--cds--visually-hidden--2nGdE";
export var hideFeedback = "PageDescription-module--hide-feedback--+NvCJ";
export var pageDescription = "PageDescription-module--page-description--lsvUN";
export var showFeedback = "PageDescription-module--show-feedback--s3mIb";
export var skeleton = "PageDescription-module--skeleton--1THlu";